/* istanbul ignore file */

// -------------------------------------------------------------------------------------------------
// media breakpoints
// -------------------------------------------------------------------------------------------------
export const BREAKPOINT_XS_MIN_WIDTH = 480;
export const BREAKPOINT_XS_MAX_WIDTH = 767; // max mobile width
export const BREAKPOINT_SM_MIN_WIDTH = 768; // min tablet and can be used for min desktop if no tablet sizes are needed
export const BREAKPOINT_SM_MAX_WIDTH = 991; // max tablet
export const BREAKPOINT_MD_MIN_WIDTH = 992; // min desktop size if you are also using tablet sizes.  Otherwise see above
export const BREAKPOINT_MD_MAX_WIDTH = 1199;
export const BREAKPOINT_LG_MIN_WIDTH = 1200;
export const BREAKPOINT_LG_MAX_WIDTH = 1599;
export const BREAKPOINT_XLG_MIN_WIDTH = 1600;
export const BREAKPOINT_XLG_MAX_WIDTH = 1899;
export const BREAKPOINT_XXLG_MIN_WIDTH = 1900;
export const BREAKPOINT_XXLG_MAX_WIDTH = 2199;
export const BREAKPOINT_XXXLG_MIN_WIDTH = 2199;

export const BREAKPOINT_MOBILE_MIN = 0;
export const BREAKPOINT_MOBILE_MAX = BREAKPOINT_XS_MAX_WIDTH;
export const BREAKPOINT_TABLET_MIN = BREAKPOINT_SM_MIN_WIDTH;
export const BREAKPOINT_TABLET_MAX = BREAKPOINT_SM_MAX_WIDTH;
export const BREAKPOINT_DESKTOP_MIN = BREAKPOINT_MD_MIN_WIDTH;
